<template>
    <div>
        <div class="mb-1">
            <label class="form-label">Card</label>
        </div>

        <div class="px-3 mb-1 d-flex align-items-center" style="position: static;">
            <div class="me-2">BG</div>
            <color-picker :color-object="card" color-field="background_color" class="mt-1"></color-picker>

            <div class="mx-2">Text</div>
            <color-picker :color-object="card" color-field="color" class="mt-1 me-4"></color-picker>

            <input type="checkbox" id="checkbox" v-model="card.show_box_shadow" class="form-check-input" @change="refresh">
            <label for="checkbox" class="ms-2">box shadow</label>
        </div>

        <div class="mb-1 d-flex align-items-center" style="position: static;">
            <div class="me-2">Border</div>
            <color-picker :color-object="card" color-field="border_color" class="mt-1"></color-picker>

            <div v-if="card.show_box_shadow" class="mx-2">Box Shadow</div>
            <color-picker v-if="card.show_box_shadow" :color-object="card" color-field="box_shadow_color"  class="mt-1"></color-picker>
        </div>

        <div class="mb-1 d-flex align-items-center">
            <input type="checkbox" id="checkbox" v-model="card.hover_state" class="form-check-input" @change="refresh">
            <label for="checkbox" class="ms-2">Include hover styles</label>
        </div>

        <div v-if="card.hover_state" class="mb-1 d-flex align-items-center">
            <div class="mx-2">Box Shadow</div>
            <color-picker :color-object="card" color-field="hover_box_shadow_color" class="mt-1" @colorSelected="onColorSelected"></color-picker>

            <select class="form-select form-control-sm w-50-pct ms-2" v-model="card.hover_effect" @change="refresh">
                <option>none</option>
                <option>float</option>
                <option>bulge</option>
            </select>
        </div>

    </div>
</template>

<script>
import ColorPicker from "../components/ColorPicker.vue";
export default {
    name: 'CardStyleEditor',
    components: {ColorPicker},
    props: ['card'],
    data () {
        return {
            model: webase.model
        }
    },
    methods: {
        onColorSelected(color) {
            console.log('CardStyleEditor, onColorSelected: ' + color)
            this.$emit('refreshTheme');
        },
        refresh() {
            this.$emit('refreshTheme');
        }
    }
}
</script>

<style>

</style>
